import * as CSS from 'csstype';
import * as React from 'react';
import { Tooltip } from 'react-tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

type Props = {
    id: string,
    children: React.ReactNode,
}

export default function ErrorTooltip(
    {
        id,
        children
    }: Props): JSX.Element {
    return (
        <>
            <Tooltip
                anchorSelect={`#${id}`}
                place={'right-end'}
                style={{width: '300px'}}
            >
                {children}
            </Tooltip>
            <a id={id}>
                <div style={{display: 'inline-block'}}>
                    <FontAwesomeIcon icon={faTriangleExclamation} style={errorTooltip}/>
                </div>
            </a>
        </>
    );
}

const errorTooltip: CSS.Properties = {
    display: 'inline-block',
    marginLeft: '4px',
    height: '16px',
    width: '16px',
    color: 'red'
}
